import {TokenScanner} from "./token/tokenScaner.mjs";
import {tokenDefinitions} from "./flavour/openlexia/lexical.mjs";
import {NodeTreeBuilder} from "./node/nodeTreeBuilder.mjs";
import {lectureRules} from "./flavour/openlexia/rules.mjs";
import {NodeHtmlFormatter} from "./node/nodeHtmlFormatter.mjs";
import {RootNode} from "./node/rootNode.mjs";
import {UniqueIdProvider} from "./node/uniqueIdProvider.mjs";

const tokenScanner = new  TokenScanner(tokenDefinitions)
const nodeTreeBuilder = new NodeTreeBuilder(lectureRules);
const nodeHtmlFormatter = new NodeHtmlFormatter(lectureRules);

const parseMarkup =(markup)=> {
    if(!markup) {return ''}

    const tokens = tokenScanner.scan(markup)
    const rootNode = nodeTreeBuilder.buildNodeTree(tokens, 0, new RootNode(), [])
    return  nodeHtmlFormatter.format(rootNode, new UniqueIdProvider())
}
export {parseMarkup}
export {parseCoursMarkup} from './coursParser.mjs';
